import OpenInNew from '@mui/icons-material/OpenInNew';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { ShareResourceGuide } from './shareResourceBannerTypes';
import { toDisplayUrl } from './shareResourceBannerUtils';

interface ShareResourceBannerGuidesProps {
  guides: readonly ShareResourceGuide[];
}

const ShareResourceBannerGuides = ({ guides }: ShareResourceBannerGuidesProps) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
      {guides.map(({ Icon, titleKey, href }) => (
        <Link
          key={titleKey}
          href={href}
          rel="noopener noreferrer"
          target="_blank"
          sx={{
            alignItems: 'center',
            borderRadius: 2,
            display: 'flex',
            gap: 1.25,
            p: 1,
            textDecoration: 'none',
            '&:hover': { backgroundColor: theme.brandV2.colors.treadGray8 },
          }}
        >
          <Box
            aria-hidden
            sx={{
              alignItems: 'center',
              backgroundColor: theme.brandV2.colors.treadGray8,
              borderRadius: 2,
              color: theme.brandV2.colors.treadGray3,
              display: 'flex',
              flexShrink: 0,
              height: 30,
              justifyContent: 'center',
              width: 30,
            }}
          >
            <Icon sx={{ fontSize: 16 }} />
          </Box>
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Typography
              variant="body2"
              sx={{ color: theme.brandV2.colors.treadGray1, fontWeight: 600 }}
            >
              {t(titleKey)}
            </Typography>
            <Typography variant="body2" sx={{ color: theme.brandV2.colors.treadGray2 }}>
              {toDisplayUrl(href)}
            </Typography>
          </Box>
          <OpenInNew
            sx={{ color: theme.palette.info.main, flexShrink: 0, fontSize: 15 }}
          />
        </Link>
      ))}
    </Box>
  );
};

export default ShareResourceBannerGuides;
